import { motion } from "framer-motion";

export const MaskedLines = ({ lines, className = "", delay = 0, immediate = false }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-2 -mb-2">
        <motion.span
          className="block"
          initial={{ y: "112%" }}
          {...(immediate
            ? { animate: { y: 0 } }
            : { whileInView: { y: 0 }, viewport: { once: true, margin: "-60px" } })}
          transition={{ duration: 0.9, delay: delay + i * 0.13, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);
